import { Alert } from "ant-design-vue";
const { ...other } = Alert;
const YwAlert = {
  ...other,
  name: "YwAlert",
};

YwAlert.install = function (Vue) {
  Vue.component(YwAlert.name, YwAlert);
};

export default YwAlert;